import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import RightTimeApi from "@/API";
import Enums from "@/enums";
import { toast } from "react-toastify";

type TestTypeRow = {
  id: number;
  name: string;
};

type DepartmentTestTypeLink = {
  departmentId: number;
  companyTestTypeId: number;
};

export default function DepartmentTestTypesTable(props: {
  department: { id: number; name: string };
  testTypes?: TestTypeRow[];
  departmentTestTypes?: DepartmentTestTypeLink[];
  adminPerms?: number[];
  refreshDepartments: () => Promise<unknown>;
}) {
  const { department, testTypes = [], departmentTestTypes = [], adminPerms, refreshDepartments } = props;
  const canEdit =
    adminPerms?.includes(Enums.ROLE_PERMS.EditJobs) ||
    adminPerms?.includes(Enums.ROLE_PERMS.EditTestTypes) ||
    adminPerms?.includes(Enums.ROLE_PERMS.CompanyAdmin) ||
    adminPerms?.includes(Enums.ROLE_PERMS.SystemAdmin);

  function isAssigned(testTypeId: number) {
    return departmentTestTypes.some(
      (link) => link.departmentId === department.id && link.companyTestTypeId === testTypeId
    );
  }

  async function toggleTestTypeAsync(testTypeId: number) {
    if (!canEdit) return;
    const resp = await RightTimeApi.putAsync(
      `/CompanyDepartment/${department.id}/CompanyTestType/${testTypeId}/Toggle`,
      {}
    );
    if (resp?.ok) {
      await refreshDepartments();
    } else {
      toast.error("Failed to update test type department assignment.");
    }
  }

  const sortedTestTypes = [...testTypes].sort((a, b) => {
    const aChecked = isAssigned(a.id);
    const bChecked = isAssigned(b.id);
    if (aChecked !== bChecked) return aChecked ? -1 : 1;
    return a.name.localeCompare(b.name);
  });

  return (
    <div className="tableWrapper factTable horizontal scrollable departmentTestTypesTable">
      <table>
        <caption>
          <span className="title">{department.name} / Test Types</span>
        </caption>
        <thead>
          <tr>
            <th>Test Type</th>
            <th className="toggleColumnHeader">Assigned</th>
          </tr>
        </thead>
        <tbody>
          {sortedTestTypes.map((testType) => {
            const assigned = isAssigned(testType.id);
            return (
              <tr key={`dept-ctt-${testType.id}`}>
                <td className="left">{testType.name}</td>
                <td
                  className="actions center"
                  onClick={() => {
                    if (canEdit) toggleTestTypeAsync(testType.id);
                  }}
                >
                  {assigned ? (
                    <MdCheckBox className={`checkbox checked actionIcon${canEdit ? "" : " disabled"}`} />
                  ) : (
                    <MdCheckBoxOutlineBlank className={`checkbox unchecked actionIcon${canEdit ? "" : " disabled"}`} />
                  )}
                </td>
              </tr>
            );
          })}
          {sortedTestTypes.length === 0 ? (
            <tr>
              <td colSpan={2} className="center">No test types available</td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
}
